import * as tokenService from "../services/token";

/**
 * Log out of the system.
 *
 * @param {string} refreshToken
 */
export async function logout(body = {}) {
  tokenService.clear();
}

/**
 * Login of the system.
 *
 * @param {object} body
 */
export async function login(body: { email: string; password: string }) {
  tokenService.clear();
}

/**
 * Get me.
 */
export async function getMe() {}

/**
 * Forget Pass.
 */
export async function forgetPass(body: { email: string }) {}
